import { DecimalPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CurrencyPricePipe } from '@delon/util';

interface CustomerRefundKnockoffItem {
  type: string;
  date: string;
  docNo: string;
  description: string;
  outstanding: number;
  amount: number;
  payment: number;
}

interface CustomerRefundAccountItem {
  accountCode: string;
  accountName: string;
  description: string;
  amount: number;
}

@Component({
  selector: 'app-transaction-preview-customer-refund',
  standalone: true,
  imports: [CurrencyPricePipe, DecimalPipe],
  templateUrl: './transaction-preview-customer-refund.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TransactionPreviewCustomerRefundComponent {
  @Input() currencyCode: string | null = null;
  @Input() knockoffItems: CustomerRefundKnockoffItem[] | null = null;
  @Input() unmatchedAmount: number | null = null;
  @Input() accountItems: CustomerRefundAccountItem[] | null = null;
  @Input() accountTotal: number | null = null;
  @Input() taxableAmount: number | null = null;
  @Input() taxAmount: number | null = null;
  @Input() netTotal: number | null = null;
}
